function rem(px) {
	const baseFont = 16
	return `${px/baseFont}rem`
}

export default rem
